module.exports = {"id":"103935","name":"Alberto Aquilani","rating":"75","photo":"./data/images/photos/0/103935.png","club":{"name":"UD Las Palmas","logo":"./data/images/clubs/UDLasPalmas.png"},"positions":["MC","MDC","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlbertoAquilani0.json
// module id = 163
// module chunks = 0